document.addEventListener("DOMContentLoaded", function () {
  const sliderTitles = new Swiper('.progress-timeline__titles', {
    loop: true,
    slidesPerView: 2.4,
    spaceBetween: 12,
    watchSlidesProgress: true,
    breakpoints: {
      981: {
        slidesPerView: 4,
        spaceBetween: 0,
      }
    }
  });

  const sliderMainContent = new Swiper('.progress-timeline__contents', {
    spaceBetween: 12,
    slidesPerView: 1.2,
    loop: true,
    thumbs: {
      swiper: sliderTitles
    },
    pagination: {
      el: '.timeline-pagination',
      clickable: true,
    },
    breakpoints: {
      981: {
        slidesPerView: 1,
      }
    }
  });
});